import {track} from "@otto-ec/nav_star-track";

export class BrandGrid extends HTMLElement {
    static customElementName = "nav-brand-grid";
    static anchorPrefix  = "nav-brand-index-"; /*                                                      */
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll('.nav_brand-grid-link-js').forEach((el) => {
            el.addEventListener('click', (event) => {
                track(event.target, 'user-action/brand-index-visit-brand');
            });
        });
    }
}
